import { getAssetCategories, getAssets } from '../../../helpers/apiCalls';
import { useEffect, useState } from 'react';
import Table from '../../../../Template/layoutComponents/Table';
import { getInterconnectionAndUniques } from '../../../helpers/apiCalls';
import useTemplateState from '../../../../Template/atoms/variables';
import useMaintenanceState from '../../../atoms/variables';
import { notification } from 'antd';
import { getInterconnectionCategories } from '../../../../Settings/helpers/apiCalls';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import TableTip from '../../../../Template/layoutComponents/Table/components/tip';

const AssetTable = ({ selectedObjects, setSelectedObjects }) => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const { plantId } = useParams();

  const [notificationApi, contextHolder] = notification.useNotification();

  const { setPendingApiCalls } = useTemplateState();
  const { assets, setAssets, setViewDetailsItem } = useMaintenanceState();

  const [allCategories, setAllCategories] = useState([]);

  useEffect(() => {
    triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) =>
        current.concat(['getInterconnectionAndUniques', 'getInterconnectionCategories']),
      );

      const responses = await Promise.all([
        getAssets(instance, { location: plantId, 'status[in]': ['Pending', 'Fail'], limit: 10 }),
        getAssetCategories(instance),
      ]);

      setAssets(responses[0]);
      setAllCategories(responses[1]?.items ?? []);
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
      console.log(err);
    } finally {
      setPendingApiCalls((current) =>
        current.filter(
          (item) =>
            item !== 'getInterconnectionAndUniques' && item !== 'getInterconnectionCategories',
        ),
      );
    }
  };

  return (
    <>
      {contextHolder}
      <Table
        handleSelect={(selected) => {
          if (selectedObjects.filter((obj) => !obj.committed).length > selected.length) {
            setSelectedObjects((current) =>
              current.filter(
                (obj) => obj.committed || selected.some((newObj) => newObj._id === obj._id),
              ),
            );
          } else
            setSelectedObjects((current) => {
              return current.concat(
                selected
                  .filter((newObj) => !current.some((obj) => obj._id === newObj._id))
                  .map((newObj) => ({ ...newObj, kind: 'Asset' })),
              );
            });
        }}
        handleRowClick={null}
        apiCall={(instance, query) =>
          getAssets(instance, { location: plantId, 'status[in]': ['Pending', 'Fail'], ...query })
        }
        items={assets?.items}
        startingTotalItems={assets.totalItems ?? 0}
        tableSettings={{
          columnsConfig: {
            category: {
              label: t('category'),
              replaceValue: (value) =>
                allCategories?.find((cat) => cat._id === value || cat.id === value),
            },
            name: {
              label: t('name'),
            },

            status: {
              label: t('status'),
              customElement: (item) => <TableTip children={item.status ?? item} />,
            },
          },
          sortable: ['category', 'name'],
          listFilter: ['category'],
          searchFilter: ['name'],
          uniqueValues: assets.uniqueValues,
        }}
      />
    </>
  );
};
export default AssetTable;
